import { render, staticRenderFns } from "./BranchCard.vue?vue&type=template&id=e8165e2e"
import script from "./BranchCard.vue?vue&type=script&lang=js"
export * from "./BranchCard.vue?vue&type=script&lang=js"
import style0 from "./BranchCard.vue?vue&type=style&index=0&id=e8165e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports